import React, { Component } from 'react';
import { Tabs, Row, Col } from 'antd';
import { connect } from 'react-redux';
import CourseForm from './../../components/courseform/courseform';
import CourseCurriculum from './../../components/coursecurriculum/coursecurriculum';
import { uploadMedia,getMedia } from '../../../../core/actions/storageStore';
import { uploadCourse } from '../../../../core/actions/coursePost';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
// import Batchupload from '../../components/batchupload';
// import Uploadedvideos from '../../components/uploadedvideos';
import { bindActionCreators } from "redux"

const TabPane = Tabs.TabPane;

class CourseUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabStyle: 'left',
      refresh:false
    };
  }
  componentWillMount() {
    // eslint-disable-next-line no-undef
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.props.history.goBack();
    }
    this.switchTabStyle()
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if(size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }
  refreshVideos = ()=>{
    this.setState({refresh:true},()=>this.setState({refresh:false}))
  }
  render() {
    const { tabStyle } = this.state
    return (
      <div>
        <TopNav history={this.props.history} />
        <section id="course-upload">
          {this.props.profile.uid?<Tabs activeKey={this.props.course.courseId?"2":"1"} size="large" defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane disabled={this.props.course.courseId?true:false} tab="Step 1 (Course Details)" key="1">
              <Row>
                <Col lg={16} sm={24}>
                  <CourseForm 
                    course={this.props.course}
                    uploadCourse={this.props.uploadCourse}
                    refreshVideos={this.refreshVideos}
                    refresh={this.state.refresh}
                    getMedia={this.props.getMedia}
                     profile={this.props.profile}
                    uploadMedia={this.props.uploadMedia} 
                    media={this.props.media}
                   />
                </Col>
              </Row>
            </TabPane>
            <TabPane disabled={this.props.course.courseId?false:true} tab="Step 2 (Curriculum)" key="2">
              <Row>
                <Col lg={16} sm={24}>
                  <CourseCurriculum 
                   refreshVideos={this.refreshVideos}
                  refresh={this.state.refresh}
                  getMedia={this.props.getMedia}
                   profile={this.props.profile}
                  uploadMedia={this.props.uploadMedia} 
                  media={this.props.media}/>
                </Col>
              </Row>
            </TabPane>
            {/* <TabPane tab="Upload Videos" key="3">
            <Row>
                <Col lg={24} sm={24} xs={24}>
                   <Batchupload 
                   refreshVideos={this.refreshVideos}
                   profile={this.props.profile}
                  uploadMedia={this.props.uploadMedia} 
                  />
                  </Col>
            </Row>
            </TabPane>
            <TabPane tab="Uploaded Videos" key="4">
            <Row>
                <Col lg={24} sm={24} xs={24}>
                   <Uploadedvideos 
                  media={this.props.media}
                  profile={this.props.profile}
                  refresh={this.state.refresh}
                   getMedia={this.props.getMedia}/>
                  </Col>
            </Row>
            </TabPane> */}
 
          </Tabs>:null}
        </section>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  uploadMedia,
  getMedia,
  uploadCourse
}, dispatch);
const mapStateToProps = state => ({
  firebase: state.firebase,
  profile: state.firebase.profile,
  course: state.course,
  media: state.getMedia.media
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseUpload);
